import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

const pkg = require('~/package');


Raven.config('//f5008b94a402668975a5a7f583308fca@sentry.baijia.com/1393', {
    release: pkg.version,
    ignoreErrors: [
        "Cannot read property 'postMessage' of null"
    ],
    tags: {
        errorTags: 'pgerrors'
    }
}).addPlugin(RavenVue, Vue).install();
